<div class="container-box">
  <app-table-header tableTitle="Modelli" (btnUpdateClick)="loadModels()">
    <app-button-new-models action-button></app-button-new-models>
  </app-table-header>
  <div class="table-container">
    <ng2-smart-table
      id="modelsTable"
      class="table-content"
      [settings]="settings"
      [source]="source"
    ></ng2-smart-table>
  </div>
</div>
